var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBulb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_128_749)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.8906 45.9083C35.317 45.9083 45.3906 35.8347 45.3906 23.4083C45.3906 10.9819 35.317 0.908325 22.8906 0.908325C10.4642 0.908325 0.390625 10.9819 0.390625 23.4083C0.390625 35.8347 10.4642 45.9083 22.8906 45.9083Z",
    fill: "#2350F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0248 35.0042C19.0248 35.7128 19.6046 36.2926 20.3133 36.2926H25.467C26.1756 36.2926 26.7554 35.7128 26.7554 35.0042V33.7158H19.0248V35.0042ZM22.8901 10.5239C17.9168 10.5239 13.8711 14.5696 13.8711 19.543C13.8711 22.6094 15.4043 25.3023 17.7364 26.9386V29.8504C17.7364 30.5591 18.3162 31.1389 19.0248 31.1389H26.7554C27.4641 31.1389 28.0439 30.5591 28.0439 29.8504V26.9386C30.3759 25.3023 31.9092 22.6094 31.9092 19.543C31.9092 14.5696 27.8635 10.5239 22.8901 10.5239ZM26.5622 24.8256L25.467 25.5986V28.562H20.3133V25.5986L19.2181 24.8256C18.3645 24.2338 17.6667 23.4443 17.1844 22.5244C16.702 21.6045 16.4493 20.5816 16.448 19.543C16.448 15.9869 19.3341 13.1008 22.8901 13.1008C26.4462 13.1008 29.3323 15.9869 29.3323 19.543C29.3323 21.6431 28.3016 23.6144 26.5622 24.8256Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_128_749"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    fill: "white",
    transform: "translate(0.390625 0.908325)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBulb);
export default __webpack_public_path__ + "static/media/icon-bulb.9f8abd8517b08c58d526cf40b7f612a9.svg";
export { ForwardRef as ReactComponent };